import { appStorage } from '../../app/storage';
import { getDayNumber } from '../../lib/utils/datetime/getDayNumber';
export function getDailyBonusHistory(date) {
    var dailyBonusHistory = appStorage.get().dailyBonusHistory.slice(0);
    var dayNumber = getDayNumber(date);
    if (dailyBonusHistory.length) {
        var last = dailyBonusHistory[dailyBonusHistory.length - 1];
        var count = dayNumber - last;
        if (count > 0) {
            if (count === 1) {
                if (dailyBonusHistory.length === 8) {
                    appStorage.inc('dailyBonusReceivedDay');
                }
                dailyBonusHistory.push(dayNumber);
                dailyBonusHistory = dailyBonusHistory.slice(-8);
            }
            else {
                dailyBonusHistory = [dayNumber];
            }
            appStorage.upd({ dailyBonusHistory: dailyBonusHistory });
        }
        else if (count < 0) {
            dailyBonusHistory = [dayNumber];
            appStorage.upd({ dailyBonusHistory: dailyBonusHistory });
        }
    }
    else {
        dailyBonusHistory = [dayNumber];
        appStorage.upd({ dailyBonusHistory: dailyBonusHistory });
    }
    return dailyBonusHistory;
}
export function getIndexes(date) {
    var dayNumber = getDayNumber(date);
    var history = getDailyBonusHistory(date);
    var receivedDayNumber = appStorage.get().dailyBonusReceivedDay;
    DEVELOPMENT && console.log(JSON.stringify({ history: history, receivedDayNumber: receivedDayNumber }));
    return [history.indexOf(dayNumber), history.indexOf(receivedDayNumber)];
}
